__webpack_require__.p = "/team-game/";